import { render, staticRenderFns } from "./AddPanelButton.vue?vue&type=template&id=751cab62&"
import script from "./AddPanelButton.vue?vue&type=script&lang=js&"
export * from "./AddPanelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports